import { TableWrapper } from '@basqet-dashboard/common/components';
import { PERMISSIONS } from '@basqet-dashboard/common/config';
import { useHasPermission } from '@basqet-dashboard/common/hooks';
import { useFetchBeneficiaries } from '@hooks/queries';
import React from 'react';

const SingleBeneficiaries = () => {
  const hasPermission = useHasPermission();
  const canExportBeneficiary = hasPermission(PERMISSIONS.BENEFICIARIES_EXPORT);

  const {
    searchQuery,
    setSearchQuery,
    beneficiaries,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isRefetching,
    isLoading,
    filterByDate
  } = useFetchBeneficiaries({ grouped: false, singles_only: false });
  let showIsFetching = (!beneficiaries.length && isLoading) || searchQuery || isRefetching;

  return (
    <TableWrapper
      data={beneficiaries}
      title="List of "
      name="single beneficiaries"
      headerName="single_beneficiaries"
      link={{ url: '/settings/beneficiary/bulk', position: 'top', text: 'See bulk beneficiaries' }}
      exportData={canExportBeneficiary}
      hasFilters
      onLoadMore={fetchNextPage}
      canLoadMore={hasNextPage}
      isFetching={showIsFetching}
      isLoading={isFetchingNextPage}
      onSearch={setSearchQuery}
      onDateFilter={filterByDate}
    />
  );
};

export { SingleBeneficiaries };
